const subPath = process.env.PUBLIC_URL || "";

export const routes = {
  home: {
    path: `${subPath}/`,
    name: "Home Page",
  },
  contactUs: {
    path: `${subPath}/contact-us`,
    name: "Contact Us",
  },
  unpaidViolation: {
    path: `${subPath}/unpaid-violation`,
    name: "Unpaid Violation",
  },
  pastViolations: {
    path: `${subPath}/past-violations`,
    name: "Past Violations",
  },
  violationDetails: {
    path: `${subPath}/violation-details`,
    name: "Violation Details",
  },
  payPal: {
    path: `${subPath}/paypal`,
    name: "Paypal Payment",
  },
  success: {
    path: `${subPath}/success`,
    name: "Payment Success",
  },
  removalInstruction: {
    path: `${subPath}/removal-instruction`,
    name: "Removal Instruction",
  },
  pageNotFound: {
    path: `${subPath}/not-found`,
    name: "Page Not Found",
  },
  pucForm: {
    path: `${subPath}/puc-form`,
    name: "PUC Form",
  },
  bootAuthorization: {
    path: `${subPath}/boot-authorization/:token`,
    name: "Boot Authorization",
  },
  bootInstall: {
    path: `${subPath}/boot-install/:token`,
    name: "Boot Install",
  },
  bootQueue: {
    path: `${subPath}/boot-queue/:token`,
    name: "Boot Queue",
  },
  firewatchInitials: {
    path: `${subPath}/firewatch-initials/:token`,
    name: "Firewatch Initials",
  },
};
